export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  env: process.env.REACT_APP_ENV,
  version: process.env.REACT_APP_VERSION,
}
